// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lato_eb80b0', '__Lato_Fallback_eb80b0'","fontWeight":400,"fontStyle":"normal"},"className":"__className_eb80b0"};